import { Rss } from 'lucide-react';
import React from 'react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../ui/Card';
const NewSubcribers = ({ subcscribers }) => {
    return (
        <Card className="shadow-elegant">
            <CardHeader>
                <CardTitle className="flex items-center gap-2">
                    <Rss className="h-5 w-5 text-primary" />
                    Yeni Aboneler
                </CardTitle>
                <CardDescription>Email reklamlarınızın yeni üyeleri</CardDescription>
            </CardHeader>
            <CardContent>

                <div className="divide-y divide-gray-200 overflow-y-auto max-h-72">
                    {subcscribers.slice(0, 3).map((sub) => (
                        <div key={sub._id} className="py-3">
                            <p className="font-medium">{sub.email}</p>
                            <p className="text-xs text-gray-400">
                                {new Date(sub.createdAt).toLocaleDateString("tr-TR", {
                                    day: "numeric",
                                    month: "long",
                                    year: "numeric",
                                })}
                            </p>
                        </div>
                    ))}

                </div>
            </CardContent>
        </Card>
    )
}

export default NewSubcribers;